import dash_api from '../../../../main/support/dash_api';
import { SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA } from '../../../../../../shared/constants';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { AvailableCampaignsForSANAdPartnerMapping } from '../../../../main/types/skadnetworkTypes';

const FetchAvailableCampaignsForSANAdPartners = new ReduxAsyncAction<
  'FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS',
  void,
  AvailableCampaignsForSANAdPartnerMapping
>('FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS');

FetchAvailableCampaignsForSANAdPartners.registerRequest(async () => {
  const { data } = await dash_api.post<AvailableCampaignsForSANAdPartnerMapping>(
    `/v1/skadnetwork/available-campaign-names`,
    {
      networks: SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA,
    }
  );

  return data;
});

export const fetchAvailableCampaignsForSANAdPartners = FetchAvailableCampaignsForSANAdPartners.request;

export const FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS =
  FetchAvailableCampaignsForSANAdPartners.actionNamespaceConstants;

export type FetchAvailableCampaignsForSANAdPartnersResponseAction = Action<
  typeof FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS.response
> & { data: AvailableCampaignsForSANAdPartnerMapping };
